import { bl_fi_item_label_link_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class FiItemLabelLinkImportFileHelperContainer extends BaseContainerModel {
  bl_fi_item_label_link_import_file_helper: bl_fi_item_label_link_import_file_helper_RowClass = new bl_fi_item_label_link_import_file_helper_RowClass();
}